package com.techspiration.webuserapp

import com.techspiration.webuserapp.api.WebTelemetry
import org.jetbrains.compose.web.renderComposable

/**
 * Tarayıcı giriş noktası. Ziyaret telemetrisi BİLEREK burada, kompozisyonun dışında tetiklenir:
 * `main()` belge yüklenmesi başına bir kez koşar, dolayısıyla recomposition veya SPA içi rota
 * değişimi ikinci bir `page_view` üretemez (bkz. [WebTelemetry.trackPageView]).
 */
fun main() {
    WebTelemetry.trackPageView()
    renderComposable(rootElementId = "root") {
        App()
    }
}
